export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true">
      <rect width="512" height="512" rx="120" fill="var(--primary)" />
      <path d="M256 128a128 128 0 1 1-128 128" fill="none" stroke="var(--surface)" strokeWidth="44" strokeLinecap="round" />
      <circle cx="256" cy="128" r="34" fill="var(--accent)" />
      <path d="M206 262l36 36 70-78" fill="none" stroke="var(--surface)" strokeWidth="36" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
